<template>
  <div class="getty-banner">
    <div
      class="header"
      :style="{ backgroundImage: `url(${this.banner.image})` }"
    >
      <div class="header-link">
        <a
          class="logo"
          href="http://www.getty.edu"
          title="The J. Paul Getty Trust"
        >
          <span
            v-if="
              this.route &&
                (this.route.includes('gci') || this.route.includes('museumed'))
            "
          >
            The Getty
          </span>
          <span v-else class="icon-getty-logo is-pulled-left" />
        </a>
        <a class="label" :class="this.route" :href="this.banner.url">
          {{ this.banner.label }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HeaderBanner",
  data() {
    return {};
  },
  props: {
    banner: Object,
    info: Object,
    route: String
  }
};
</script>

<style lang="scss" scoped>
.getty-banner {
  position: relative;
  margin-top: -2.2em;
  z-index: 0;
}
.header {
  height: 133px;
  background-color: #eeeeee;
  background-repeat: no-repeat;
  background-position: 0px 28px;
  &-link {
    padding-top: 2.75em;
    .logo {
      float: left;
      padding: 1em;
      margin-top: -1em;
      margin-left: 2em;
      font-size: 0.5em;
      color: transparent;
    }
    .label {
      color: transparent;
      display: inline;
      font-size: 2.25em;
      margin-left: -2em;
      &.kim,
      &.go,
      &.virtuallibrary {
        color: $black;
      }
    }
  }
}
</style>
